export default "__VITE_ASSET__pL8QNgkz__"